/* Matmuis: zwevende app-knoppen rond de custom muismat (10 okt 2026)
   Chat (Shopify Inbox) staat uit op alles wat met de custom muismat te maken heeft:
   - productpagina custom muismat, ontwerptool (/apps/zakeke), zakelijke pagina (muismatten met logo)
   - winkelwagenpagina als er een custom muismat in zit
   - zolang de winkelwagen (slide-in) open is, op elke pagina: dan ligt de chat niet over 'Afrekenen'
   Zolang de ontwerptool open is, verdwijnen ook andere zwevende app-knoppen (herroeping, cookies, reviews),
   want die lagen over de 'In winkelwagen'-knop van de editor. Knoppen van Zakeke zelf worden nooit geraakt. */
(function () {
  if (window.mmEditorFix) return;
  window.mmEditorFix = true;

  var CHAT_RE = /chat|inbox/i;
  var APP_RE = /chat|inbox|widerruf|withdrawal|herroep|cookie|consent|gdpr|webwinkelkeur|valued|wwk|kiyoh|trustpilot/i;
  var CUSTOM_PAGE = /\/products\/custom-muismat|\/apps\/zakeke|\/pages\/bulkbestelling-muismatten/i.test(location.pathname);

  function editorOpen() {
    if (/\/apps\/zakeke/i.test(location.pathname)) return true;
    var frames = document.querySelectorAll('iframe[src*="zakeke"]');
    for (var i = 0; i < frames.length; i++) {
      var r = frames[i].getBoundingClientRect();
      if (r.width > window.innerWidth * 0.6 && r.height > window.innerHeight * 0.6) return true;
    }
    return false;
  }

  function noChat() {
    if (CUSTOM_PAGE) return true;
    if (document.querySelector('cart-drawer.active')) return true;
    if (/^\/cart\/?$/i.test(location.pathname) && document.querySelector('main a[href*="/products/custom-muismat"]')) return true;
    return false;
  }

  function label(el) {
    var cls = typeof el.className === 'string' ? el.className : (el.getAttribute('class') || '');
    var s = el.tagName + ' ' + (el.id || '') + ' ' + cls;
    var fr = el.tagName === 'IFRAME' ? el : el.querySelector('iframe');
    if (fr) s += ' ' + (fr.getAttribute('src') || '') + ' ' + (fr.getAttribute('title') || '') + ' ' + (fr.id || '');
    return s;
  }

  function isZakeke(el) {
    return /zakeke/i.test(label(el)) || !!(el.querySelector && el.querySelector('[src*="zakeke"]'));
  }

  function show(el) {
    el.style.removeProperty('visibility');
    el.style.removeProperty('pointer-events');
    el.removeAttribute('data-mm-hidden');
  }

  function hide(el) {
    el.style.setProperty('visibility', 'hidden', 'important');
    el.style.setProperty('pointer-events', 'none', 'important');
    el.setAttribute('data-mm-hidden', '1');
  }

  function scan() {
    var open = editorOpen();
    var chatOff = open || noChat();
    var root = document.documentElement;
    root.classList.toggle('mm-editor-open', open);
    root.classList.toggle('mm-no-chat', chatOff);

    /* Terugzetten wat niet meer verborgen hoeft te zijn */
    document.querySelectorAll('[data-mm-hidden]').forEach(function (el) {
      var isChat = CHAT_RE.test(label(el));
      if ((isChat && !chatOff) || (!isChat && !open)) show(el);
    });
    if (!chatOff) return;

    var re = open ? APP_RE : CHAT_RE;
    document.querySelectorAll('body > *, body > * > *, body > * > * > *').forEach(function (el) {
      if (el.hasAttribute('data-mm-hidden') || el.closest('cart-drawer') || isZakeke(el)) return;
      var cs = window.getComputedStyle(el);
      if (cs.position !== 'fixed' || cs.display === 'none') return;
      var r = el.getBoundingClientRect();
      if (r.width === 0 || r.height === 0 || r.width > 420 || r.height > 640) return;
      if (!re.test(label(el))) return;
      hide(el);
    });
  }

  var style = document.createElement('style');
  style.textContent = 'html.mm-no-chat #shopify-chat, html.mm-no-chat inbox-online-store-chat { display: none !important; }';
  document.head.appendChild(style);

  scan();
  setInterval(scan, 500);
  window.addEventListener('resize', scan);
})();